export * from './tour-detail.component';
export * from './tour-detail.component.module';